import module from '@kendu/ui/module'
import { element } from 'angular'

export class KdControlComponent {
  constructor ($attrs, $element) {
    this.labelElement = element('<label class="kd-control_label"></label>')
    this.attrs = $attrs
    this.element = $element
  }

  $postLink () {
    this.element.prepend(this.labelElement)
  }

  $onInit () {
    this.attrs.$addClass('kd-control')
  }

  setFocus (focus) {
    if (focus) {
      this.element.addClass('kd-control--focused')
    } else {
      this.element.removeClass('kd-control--focused')
    }
  }

  setLabel (label) {
    this.labelElement.text(label)
  }

  setRequired (required) {
    if (required) {
      this.labelElement.addClass('kd-control_label--required')
    } else {
      this.labelElement.removeClass('kd-control_label--required')
    }
  }
}

module.component('kdControl', {
  controller: KdControlComponent,
})



// WEBPACK FOOTER //
// ./src/kendu/ui/components/kd-control/component.js